import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "xver_token";
export const ADMIN_TOKEN_KEY = "xver_admin_token";

const withToken = (key) => {
  const inst = axios.create({ baseURL: API });
  inst.interceptors.request.use((c) => {
    const t = localStorage.getItem(key);
    if (t) c.headers.Authorization = `Bearer ${t}`;
    return c;
  });
  return inst;
};

export const api = withToken(TOKEN_KEY);
export const adminApi = withToken(ADMIN_TOKEN_KEY);

export const fileUrl = (p) => (p ? `${API}/files/${p}` : null);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Bir hata oluştu";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

export const fmt = (n, d = 2) =>
  Number(n || 0).toLocaleString("tr-TR", { minimumFractionDigits: d, maximumFractionDigits: d });

export const fmtMult = (m) => `${fmt(m)}×`;

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" }) : "-");

export const STATUS_TR = {
  pending: { t: "Beklemede", c: "#f5a623" },
  awaiting_payment: { t: "Ödeme Bekleniyor", c: "#b1bad3" },
  approved: { t: "Onaylandı", c: "#00e701" },
  rejected: { t: "Reddedildi", c: "#ed4163" },
  expired: { t: "Süresi Doldu", c: "#6f7790" },
  cancelled: { t: "İptal", c: "#6f7790" },
};

export const GAME_CARD_IMG =
  "https://customer-assets-agu9un31.emergentagent.net/job_xver-casino-platform/artifacts/bteyi683_file_0000000091a0820a8f7996df19566605.png";
